/* eslint-disable jsx-a11y/anchor-is-valid */
import "../../stylesheets/stories-package/stories.less";

import * as React from "react";
import seedrandom from "seedrandom";

import domainForStory from "./domain-for-story.ts";
import type {Story} from "./queries/stories-query.tsx";

type Props = {
    onClick: () => unknown;
    story: Story;
};

class StoryTeaser extends React.Component<Props> {
    handleClick: (e: React.SyntheticEvent<EventTarget>) => void = (
        e: React.SyntheticEvent<any>,
    ) => {
        e.preventDefault();
        this.props.onClick();
    };

    render(): React.ReactNode {
        const story = this.props.story;
        // Seed new RNG with key for consistent seed
        const random = seedrandom(story.key);

        let content;
        if (story.youtube_id) {
            content = (
                <div
                    className="story-teaser__thumbnail"
                    style={{
                        backgroundImage: `url(${`https://img.youtube.com/vi/${story.youtube_id}/hqdefault.jpg`})`,
                    }}
                />
            );
        } else {
            content = (
                <div className="story-teaser__content">
                    <p>{story.story}</p>
                </div>
            );
        }

        const domain = domainForStory(story);
        return (
            <a
                href="#"
                className={"story-teaser " + domain}
                onClick={this.handleClick}
                style={{
                    maxHeight: 280 + Math.floor(120 * random()),
                }}
            >
                <div className={"story-teaser__title-box " + domain}>
                    <h3 className="story-teaser__name">{story.name}</h3>
                </div>
                {content}
            </a>
        );
    }
}

export default StoryTeaser;
